import React, { useEffect, useRef, useState } from 'react';
import cn from 'classnames';
import './styles.scss';
import shortid from 'shortid';
import Element from '../Element';
import { View } from '..';

const Checkbox: React.FC<CheckboxProps> = ({ label, className, disabled, style, ...props }) => {
  const id = useRef(shortid.generate());

  return (
    <View isRow className={cn('cmp-checkbox', { 'cmp-checkbox__disabled': disabled }, className)} style={style}>
      <input
        id={id.current}
        type="checkbox"
        className={cn('cmp-checkbox__input')}
        style={{ display: 'none' }}
        {...props}
      />
      <label htmlFor={id.current} className={cn('cmp-checkbox__label', 'check')}>
        <svg width="18px" height="18px" viewBox="0 0 18 18">
          <path d="M1,9 L1,3.5 C1,2 2,1 3.5,1 L14.5,1 C16,1 17,2 17,3.5 L17,14.5 C17,16 16,17 14.5,17 L3.5,17 C2,17 1,16 1,14.5 L1,9 Z" />
          <polyline points="1 9 7 14 15 4" />
        </svg>
        <span className={cn('cmp-checkbox__label--text')}>{label}</span>
      </label>
    </View>
  );
};

type CheckboxProps = React.HTMLProps<HTMLInputElement> & {
  label?: string;
};

const Group: React.FC<CheckboxGroupProps> = ({
  label,
  options,
  name,
  onChange = () => {},
  value = [],
  errorMessage,
  containerClassName,
  columns = 2,
  disabled,
}) => {
  const [data, setData] = useState<any[]>(value);

  useEffect(() => {
    onChange(data);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [data]);

  const handleValueChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const target = event.target as HTMLInputElement;
    const key = target.value;

    const isChecked = data?.indexOf(key) >= 0;

    let updated = [];
    if (isChecked) {
      updated = data?.filter(x => x !== key);
    } else {
      updated = [...data, key];
    }

    setData(updated);
  };

  return (
    <Element errorMessage={errorMessage} label={label} className={containerClassName}>
      <View isRow>
        {options?.map((option, index) => (
          <Checkbox
            key={`checkbox-${name}-${index}`}
            value={option.value}
            checked={data?.indexOf(option.value) >= 0}
            label={option.label}
            onChange={handleValueChange}
            className={cn(columns && 'cmp-checkbox-group__column')}
            style={{ width: `${100 / columns}%` }}
            disabled={disabled}
            name={name}
          />
        ))}
      </View>
    </Element>
  );
};

type CheckboxGroupProps = {
  label?: string;
  options?: { value: any; label: string }[];
  value?: any[];
  name?: string;
  onChange?: (...arg: any[]) => void;
  errorMessage?: string;
  containerClassName?: string;
  labelClassName?: string;
  description?: string;
  columns?: number;
  disabled?: boolean;
};

export default { Item: Checkbox, Group };
